import React, { Fragment } from "react";
import Moment from "react-moment";
import FileViewer from "react-file-viewer";
import FileViewerError from "../../FileViewer/FileViewerError";

const ApplicantResume = ({
  setShowResume,
  applicantResume,
  download,
  setDownload,
}) => {
  return (
    <Fragment>
      <div className="modal-overlay">
        {applicantResume.imeapplicant && applicantResume.imeresume && (
          <div className="resume-view">
            <i
              className="fas fa-times fa-2x message-x"
              onClick={() => {
                setDownload(false);
                setShowResume(false);
              }}
            ></i>
            <div className="flex-center">
              <div className="online-avi-container">
                <div className="avi-color-border green">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${applicantResume.avatar}`}
                    className="drop-down-result-avi"
                    alt="avatar"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="green name-font bold">
                      {applicantResume.firstname} {applicantResume.lastname}
                    </span>
                  </li>
                  <li className="user-online-item">
                    {applicantResume.jobtitle}
                  </li>
                  <li className="user-online-item">
                    {applicantResume.location.city},{" "}
                    {applicantResume.location.state}
                  </li>
                </ul>
              </div>
            </div>
            <div className="applicant-info">
              <div className="single-section">
                <div className="flex-only">
                  <p className="sub-section green">Professional Summary</p>
                </div>
                <p className="summary">{applicantResume.professionalsummary}</p>
              </div>
              {applicantResume.education.length > 0 &&
                applicantResume.education.map((item) => {
                  return (
                    <div className="single-section" key={item._id}>
                      <div className="lower-section">
                        <div>
                          <p className="sub-section-years green">Education</p>
                          <div className="app-years">
                            <p className="app-year green">
                              <Moment format="MM/DD/YYYY">{item.from}</Moment> -{" "}
                              <Moment format="MM/DD/YYYY">{item.to}</Moment>
                            </p>
                          </div>
                        </div>
                        <div className="side-info">
                          <p className="applicant-side-title">
                            {item.institution}
                          </p>
                          <ul className="education-items">
                            {item.description.map((listitem) => {
                              return (
                                <li
                                  className="education-item"
                                  key={listitem._id}
                                >
                                  <i class="fas fa-asterisk mr-5 white fa-sm"></i>
                                  {listitem.item}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {applicantResume.experience.length > 0 &&
                applicantResume.experience.map((item) => {
                  return (
                    <div className="single-section">
                      <div className="lower-section">
                        <div>
                          <p className="sub-section-years green">Experience</p>
                          <div className="app-years">
                            <p className="app-year green">
                              <Moment format="MM/DD/YYYY">{item.from}</Moment> -{" "}
                              <Moment format="MM/DD/YYYY">{item.to}</Moment>
                            </p>
                          </div>
                        </div>
                        <div className="side-info">
                          <p className="applicant-side-title">
                            {item.employer}
                          </p>
                          <ul className="education-items">
                            {item.description.map((listitem) => {
                              return (
                                <li
                                  className="education-item"
                                  key={listitem._id}
                                >
                                  <i class="fas fa-asterisk mr-5 white fa-sm"></i>
                                  {listitem.item}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {applicantResume.skills.length > 0 &&
                applicantResume.skills.map((item) => {
                  return (
                    <div className="single-section">
                      <div className="lower-section">
                        <div>
                          <p className="sub-section-years green">Skills</p>
                          <div className="app-years">
                            <p className="app-year green">
                              <Moment format="MM/DD/YYYY">{item.from}</Moment> -{" "}
                              <Moment format="MM/DD/YYYY">{item.to}</Moment>
                            </p>
                          </div>
                        </div>
                        <div className="side-info">
                          <p className="applicant-side-title">
                            {item.skillname}
                          </p>
                          <ul className="education-items">
                            {item.description.map((listitem) => {
                              return (
                                <li
                                  className="education-item"
                                  key={listitem._id}
                                >
                                  <i class="fas fa-asterisk mr-5 white fa-sm"></i>
                                  {listitem.item}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
        {applicantResume.imeapplicant && !applicantResume.imeresume && (
          <div className="resume-view">
            <i
              className="fas fa-times fa-2x message-x"
              onClick={() => {
                setDownload(false);
                setShowResume(false);
              }}
            ></i>
            <div className="flex-center">
              <div className="online-avi-container">
                <div className="avi-color-border green">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${applicantResume.avatar}`}
                    className="drop-down-result-avi"
                    alt="avatar"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="green name-font bold">
                      {applicantResume.firstname} {applicantResume.lastname}
                    </span>
                  </li>
                  <li className="user-online-item">
                    {applicantResume.jobtitle}
                  </li>
                  <li className="user-online-item">
                    {applicantResume.location.city},{" "}
                    {applicantResume.location.state}
                  </li>
                </ul>
              </div>
            </div>
            <div className="applicant-info-alt">
              <div className="document-applicant">
                <FileViewer
                  fileType={applicantResume.documentType}
                  filePath={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/resume_attachments${applicantResume.resumePath}`}
                  errorComponent={FileViewerError}
                  onError={FileViewerError}
                />
              </div>
              <div className="create-post-button-container">
                <button
                  className="create-post-button background-dark-black white"
                  onClick={() => {
                    setDownload(true);
                  }}
                >
                  <i className="fas fa-download green mx-5"></i>Download File
                </button>
                {download && (
                  <iframe
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/resume_attachments${applicantResume.resumePath}`}
                    className="file-upload"
                    title="resume"
                  ></iframe>
                )}
              </div>
            </div>
          </div>
        )}
        {!applicantResume.imeapplicant && (
          <div className="resume-view">
            <i
              className="fas fa-times fa-2x message-x"
              onClick={() => setShowResume(false)}
            ></i>
            <div className="flex-center">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="green name-font bold">
                      {applicantResume.firstname}
                    </span>
                  </li>
                  <li className="user-online-item">
                    {applicantResume.jobtitle}
                  </li>
                  <li className="user-online-item">
                    {applicantResume.location.city},{" "}
                    {applicantResume.location.state}
                  </li>
                </ul>
              </div>
            </div>
            <div className="applicant-info-alt">
              <div className="document-applicant">
                <FileViewer
                  fileType={applicantResume.documentType}
                  filePath={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/resume_attachments${applicantResume.resumePath}`}
                  errorComponent={FileViewerError}
                  onError={FileViewerError}
                />
              </div>
              <div className="create-post-button-container">
                <button
                  className="create-post-button background-dark-black white"
                  onClick={() => {
                    setDownload(true);
                  }}
                >
                  <i className="fas fa-download green mx-5"></i>Download File
                </button>
                {download && (
                  <iframe
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/resume_attachments${applicantResume.resumePath}`}
                    className="file-upload"
                    title="file"
                  ></iframe>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default ApplicantResume;
